var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-2-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83334 25.8333H27.1667V16.5H29.8333V27.1667C29.8333 27.9031 29.2364 28.5 28.5 28.5H4.50001C3.76363 28.5 3.16667 27.9031 3.16667 27.1667V16.5H5.83334V25.8333ZM17.8333 12.5V21.8333H15.1667V12.5H8.5L16.5 4.5L24.5 12.5H17.8333Z",
    fill: "#667085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2Line);
export default __webpack_public_path__ + "static/media/upload-2-line.664a680790fb5228fcd071b43b54d788.svg";
export { ForwardRef as ReactComponent };